import { useState } from "react";
import { NavLink } from "react-router-dom";
import { NAV_ITEM_CLASSES } from "@/helper/helper";
import SideMenuCollapseBtn from "./SideMenuCollapseBtn";
import SignOutMenuItem from "./SignOutMenuItem";
import { useAppSelector } from "@/hooks/useAppSelector";

function SideMenu() {
  const [isOpen, setIsOpen] = useState(true);
  const { user } = useAppSelector((state) => state.system);

  function toggleMenu() {
    document.getElementsByTagName("body")[0]?.classList.toggle("menu-closed");
    setIsOpen((prev) => !prev);
  }

  const USER_NAV_ITEMS = [
    {
      route: "/household",
      name: "Household",
    },
  ];

  const LOCAL_ADMIN_NAV_ITEMS = [
    {
      route: "/open-dictionary",
      name: "Open Dictionary",
    },
    {
      route: "/user",
      name: "Users",
    },
    {
      route: "/stock",
      name: "Stock",
    },
    {
      route: "/document-template",
      name: "Document Template",
    },
    {
      route: "/admin-console",
      name: "Organization Settings",
    },
  ];

  const GLOBAL_ADMIN_NAV_ITEMS = [
    {
      route: "/global-admin-console",
      name: "Global Administration",
    },
  ];

  return (
    <div className="container-menu flex h-full flex-col justify-between bg-primary py-4 pl-4">
      <div className="relative flex h-full w-full flex-col text-sm">
        {USER_NAV_ITEMS.map(({ name, route }) => (
          <NavLink state={true} key={route} className={NAV_ITEM_CLASSES} to={route}>
            {name}
          </NavLink>
        ))}

        {user?.isLocalAdmin &&
          LOCAL_ADMIN_NAV_ITEMS.map(({ name, route }) => (
            <NavLink state={true} key={route} className={NAV_ITEM_CLASSES} to={route}>
              {name}
            </NavLink>
          ))}

        {user?.isGlobalAdmin &&
          GLOBAL_ADMIN_NAV_ITEMS.map(({ name, route }) => (
            <NavLink state={true} key={route} className={NAV_ITEM_CLASSES} to={route}>
              {name}
            </NavLink>
          ))}

        <SignOutMenuItem />
      </div>
      <SideMenuCollapseBtn isOpen={isOpen} clickHandler={toggleMenu} />
    </div>
  );
}

export default SideMenu;
